var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "mds-tabs",
    _vm._l(_vm.tabs, function (tab, index) {
      return _c(
        "mds-tabs-item",
        {
          key: index,
          attrs: { active: tab.isActive },
          on: {
            "mds-tabs-item-active": function ($event) {
              return _vm.$emit("tabClick", tab)
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.translate(tab.name)) + "\n  ")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }